import * as R from "ramda";

export const transformFromApiToForm = question =>
  R.pipe(
    R.evolve({
      options: R.map(option => ({
        text: option,
        isValid: R.defaultTo([], question.validOptions).includes(option)
      }))
    }),
    R.when(
      R.prop("validRange"),
      R.mergeLeft({
        min: R.path(["validRange", 0], question),
        max: R.path(["validRange", 1], question)
      })
    ),
    R.omit(["validOptions", "validRange"])
  )(question);

export const transformFromFormToApi = question =>
  R.pipe(
    R.when(
      R.allPass([R.prop("knockout"), R.has("min"), R.has("max")]),
      R.pipe(
        R.assoc("validRange", [question.min, question.max]),
        R.omit(["min", "max"])
      )
    ),
    R.when(
      R.prop("options"),
      R.pipe(
        R.when(
          R.propEq("knockout", true),
          R.assoc(
            "validOptions",
            R.pipe(
              R.defaultTo([]),
              R.filter(R.propEq("isValid", true)),
              R.map(R.prop("text"))
            )(question.options)
          )
        ),
        R.evolve({ options: R.map(R.prop("text")) })
      )
    )
  )(question);
